var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container",staticClass:"clamp-text"},[_c('span',{ref:"content"},[_vm._v(_vm._s(_vm.clampedText))]),(_vm.isClamped)?_c('span',{staticClass:"ellipsis"},[_vm._v("…")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }